import { render, staticRenderFns } from "./global-button-parallelogram.vue?vue&type=template&id=08f2d618&scoped=true&"
import script from "./global-button-parallelogram.vue?vue&type=script&lang=js&"
export * from "./global-button-parallelogram.vue?vue&type=script&lang=js&"
import style0 from "./global-button-parallelogram.vue?vue&type=style&index=0&id=08f2d618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2d618",
  null
  
)

export default component.exports